import dealersLanding from 'features/dealers/landing';
import dealerDetail from 'features/dealers/dealer-detail';
import dealerPanel from 'features/dealers/panel';

export default {
  dealersLanding: dealersLanding,
  dealerDetail: dealerDetail,
  dealerPanel: dealerPanel
};
